(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CompanyCore", [], factory);
	else if(typeof exports === 'object')
		exports["CompanyCore"] = factory();
	else
		root["CompanyCore"] = factory();
})(this, function() {
return 